import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import { routerService } from '@/services';
import { CEC, ROUTES, SINGLE_PAGES } from '@/constants';
import { getSearchParam } from '@/utils';

const RouteListener = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const matchParams = useParams();

  const prevLocationRef = useRef(null);
  const prevLocation = prevLocationRef.current;

  if (!new RegExp(`^${CEC}`).test(location.pathname)) {
    window.location.replace(ROUTES.HOME);
  }

  useEffect(() => {
    if (getSearchParam('T') || getSearchParam('R')) {
      navigate({ pathname: ROUTES.ERROR, search: location.search });
    }

    dispatch({
      type: 'routerModel/setState',
      payload: {
        singlePage: SINGLE_PAGES.find((e) => location.pathname.indexOf(e) > -1),
        location,
        matchParams,
      },
    });

    /* Matomo */
    if (window._paq && prevLocation) {
      // Let Matomo know whenever the URL changes.
      _paq.push(['setReferrerUrl', prevLocation.pathname]);
      _paq.push(['setCustomUrl', window.location.href]);
      // Resetting previously set custom dimensions.
      Object.values(window._platformInfo.customDimensions).forEach((customDimensionId) =>
        _paq.push(['deleteCustomDimension', customDimensionId]),
      );
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
    }
    prevLocationRef.current = location;
  }, [location.pathname, location.search]);

  useEffect(() => {
    routerService.setNavigate(navigate);
  }, [navigate]);

  return null;
};

export default RouteListener;
